import request from '@/utils/request';
//商品管理一览列表
export function getGoodsList(param) {
  return request('/gift/queryPage', {
    method: 'POST',
    data: param,
  });
}
//改变商品状态
export function changeGoodStatus(param) {
  return request('/gift/changeStatus', {
    method: 'POST',
    data: param,
  });
}
//删除商品
export function deleteGood(param) {
  return request('/gift/delete', {
    method: 'POST',
    data: param,
  });
}
//门店列表
export function getStoreList(values) {
  return request('/store/queryPage', {
    method: 'POST',
    data: values,
  });
}

//新增会员列表
export function addMember(values) {
  return request('/membership/members', {
    method: 'POST',
    data: values,
  });
}
